import { fetchAddressCodesApi } from "@/api/services/global/constant";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useQuery } from "@tanstack/react-query";

export const useGetAddressCodeList = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_ADDRESS_CODES],
    queryFn: () => fetchAddressCodesApi(),
  });
};
